"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TimerDisplay = exports.TimerButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("@react-aria/utils");
var _button = require("@react-aria/button");
var _focus = require("@react-aria/focus");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Icon = require("../../../deprecated/atoms/Icon");
var _tokens = _interopRequireDefault(require("../../../forecast-v2/shared/tokens/tokens"));
var _jsxRuntime = require("react/jsx-runtime");
var StyledButton = _styledComponents.default.button.withConfig({
  displayName: "Timer__StyledButton",
  componentId: "sc-4hk71k-0"
})(["display:flex;justify-content:center;align-items:center;width:44px;height:44px;border-radius:8px;cursor:pointer;border:none;background:transparent;&:hover{background:", ";}&:focus{outline:none;}&.focus-ring{box-shadow:", ";}&:disabled{&:hover{background:transparent;}svg{path{fill:#d3d3df;}}}"], _tokens.default.sky.comp.button.color.background.lowemphasis.hover, _tokens.default.sky.sys.elevation.shadow.focusring);
var StyledTimer = _styledComponents.default.div.withConfig({
  displayName: "Timer__StyledTimer",
  componentId: "sc-4hk71k-1"
})(["display:flex;flex-direction:row;align-items:center;"]);

// TODO: Change when token system is in place
var StyledDisplay = _styledComponents.default.div.withConfig({
  displayName: "Timer__StyledDisplay",
  componentId: "sc-4hk71k-2"
})(["padding:0 8px;font-family:Inter,sans-serif;font-style:normal;font-weight:400;font-size:16px;line-height:24px;color:#393946;"]);
var TimerButton = exports.TimerButton = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var icon = _ref.icon,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {
      return void 0;
    } : _ref$onClick,
    ariaLabel = _ref['aria-label'];
  var objectRef = (0, _utils.useObjectRef)(ref); // Aria requires some massaging to work with forwarded refs. See this thread: https://github.com/adobe/react-spectrum/issues/834
  var _ref4 = (0, _button.useButton)({
      isDisabled: disabled,
      onPress: onClick,
      'aria-label': ariaLabel
    }, objectRef),
    buttonProps = _ref4.buttonProps;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_focus.FocusRing, {
    focusRingClass: "focus-ring",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledButton, _objectSpread({}, buttonProps, {
      ref: ref,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        icon: icon,
        size: "m"
      })
    }))
  });
});
var TimerDisplay = function TimerDisplay(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledDisplay, {
    children: children
  });
};
exports.TimerDisplay = TimerDisplay;
var Timer = function Timer(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTimer, {
    children: children
  });
};
Timer.Button = TimerButton;
Timer.Display = TimerDisplay;
var _default = exports.default = Timer;